import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const SectionWrapper = styled.section`
  position: relative;
  z-index: 10;
  padding: 20px 0;
  .container {
    @media only screen and (min-width: 1367px) {
      max-width: 1290px;
    }
  }
`;

export const Panel = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 56px;
  border-radius: 16px;
  padding: 60px 72px;
  background: linear-gradient(135deg, #0c4657 0%, #15697f 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 24px 60px rgba(6, 40, 51, 0.22);

  /* gentle top sheen */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
      120% 130% at 100% 0%,
      rgba(255, 255, 255, 0.12) 0%,
      rgba(255, 255, 255, 0) 55%
    );
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  @media only screen and (max-width: 991px) {
    gap: 40px;
    padding: 50px 48px;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 32px;
    padding: 44px 28px;
  }
`;

export const Badge = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 156px;
  height: 156px;
  background-color: ${themeGet('colors.white', '#ffffff')};
  border-radius: 24px;
  box-shadow: 0 16px 34px rgba(6, 40, 51, 0.28);
`;

export const Divider = styled.div`
  flex-shrink: 0;
  width: 1px;
  height: 150px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.22) 20%,
    rgba(255, 255, 255, 0.22) 80%,
    rgba(255, 255, 255, 0) 100%
  );
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media only screen and (max-width: 768px) {
    align-items: center;
  }

  h2 {
    color: ${themeGet('colors.white', '#ffffff')};
    font-size: 30px;
    line-height: 1.3;
    font-weight: 700;
    letter-spacing: -0.5px;
    margin: 0 0 12px;
    max-width: 540px;
    @media only screen and (max-width: 991px) {
      font-size: 26px;
    }
  }

  .cert-desc {
    color: rgba(255, 255, 255, 0.82);
    font-size: 15px;
    line-height: 1.75;
    margin: 0 0 22px;
    max-width: 540px;
  }

  .cert-verify {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: ${themeGet('colors.white', '#ffffff')};
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.2px;
    text-decoration: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    padding-bottom: 3px;
    transition: border-color 0.2s ease, gap 0.2s ease;
    span {
      transition: transform 0.2s ease;
    }
    &:hover {
      border-color: #ffffff;
      span {
        transform: translateX(3px);
      }
    }
  }
`;
